import { exportToExcel } from "../../../../common-utilities/utils";

export const downloadReports = (data) => {
  if (!data?.length) {
    return;
  }
  const results =
    data?.map?.((item) => {
      const site = item?.site;
      const document = item?.document;
      const storeName =
        site?.code || site?.name
          ? `${site?.code || ""}${site?.code && " - "}${site?.name || ""}`
          : `${document?.siteCode || ""}${
              document?.siteCode && " - "
            }${document?.siteName || ""}`;
      const stages = item?.stages || [];
      const lastStage = stages[stages.length - 1];
      return {
        "PR Number": document?.prNumber || item?.documentId || null,
        Store: storeName,
        Department: document?.department || null,
        "PR Type": document?.prType || null,
        "Total Amount": document?.totalEstimatedGrossAmount || null,
        "Current Stage": lastStage?.stageName || lastStage?.stageRoleName || null,
        Date: item?.createdAt
          ? new Date(item.createdAt).toLocaleDateString("en-IN")
          : null,
        "Pending With": item?.pendingWith || null,
        "Created By": document?.creatorName || null,
      };
    }) || [];

  exportToExcel(results, "pending_pr_actions");
};
